/* eslint-disable */
// reducers
import {
    TOGGLE_LOADING,
    FETCH_ACCOUNT_LIST,
    UNAUTHORIZED_ACCOUNT,
    USER_ACTIVITY_ACCOUNT_DETAILS,
    STAR_DATA
  } from "../../constants/AccountActionTypes";
  
const initialState = {
    loading: false,
    account_list: null,
    unAuthorisedAccount: null,
    account_details: null,
    starData: null
  };
  
  const accountReducer = (state = initialState, { type, payload }) => {
    switch (type) {
      case TOGGLE_LOADING:
            return { ...state, loading: payload };
      case UNAUTHORIZED_ACCOUNT:
        return { ...state, unAuthorisedAccount: payload };
      case FETCH_ACCOUNT_LIST:
        return { ...state, account_list: payload };
      case USER_ACTIVITY_ACCOUNT_DETAILS:
        return { ...state, account_details: payload }
      case STAR_DATA:
        return { ...state, starData: payload }
      default:
        return state;
    }
  };
  export default accountReducer;  